// number lib
import isNumber from 'is-number';
import twoDecimals from './twoDecimals.lib.number';

const convertFromMillions = (number) =>
  isNumber(number) ? twoDecimals(number * 1000000) : number;

export default convertFromMillions;
